<template>
  <div class="chartbox">
    <div class="time" v-if="data.newtime"><span>{{ data.newtime }}</span></div>
    <div class="sysmess" v-if="data.type==11 || data.type==14" v-html="data.content"></div>
    <div class="message" :class="{'other':data.userType==2,'my':data.userType==1}" v-else>
      <img class="avatar" :src="hand(data.userType,data.chatType)" />
      <div class="content">
        <!-- <div class="nickname">{{ data.nickname }}</div> -->
        <div class="bubble">
          <div class="name">{{ data.nickname }}</div>
          <modelMess :type="data.type" :content="data.content" :isHis="isHis"></modelMess>
          <div class="quesBox" v-if="data.quotedMessageId" @click="scrollBarDirKey(data.quotedMessageId)">
            <div class="quesName">{{data.quotedMessage?.nickname}}：</div>
            <div class="quesSay quesMess" v-html="processedContent(data.quotedMessage?.message)" v-if="data.quotedMessage?.type==10"></div>
            <div class="quesSay" v-html="data.quotedMessage?.message" v-else></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import modelMess from './modelMess.vue'
  import {
    processedContent
  } from '@/assets/js/index'
  export default {
    props: {
      data: Object,
      user: Object,
      isHis: Boolean
    },
    components: {
      modelMess
    },
    methods: {
      scrollBarDirKey(id) {
        this.$emit('scrollBarDirKey', id)
      },
      processedContent,
      hand(type, chatType) { //头像
        if (type == 1) return this.data.avatar || this.user.userHeadImage || require('@/assets/images/hand.png')
        else return this.user.supplierHeadImage || require('@/assets/images/aqghand.png')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/item.scss';
  .quesBox {
    display: flex;
    margin-top: 8px;
    .quesName {
      color: #777;
      font-size: 10px;
    }
     :deep {
      .proli,
      .ordli {
        max-width: 200px;
        padding:  8px;
        background: #f7f5f5;
        border-radius: 8px;
        img{
          width: 40px;
          height:40px;
        }
        .a {
          display: flex;
          .ordertit {
            color: #777;
            font-size: 11px;
          }
          .mains {
            img {
              width: 40px;
            }
  
          }
        }
      }
      .quesSay {
        img {
          width: 40px;
          
        }
      }
      .quesMess {
        color: #a6a6a6;
        max-width: 70%;
        font-size: 10px;
        img {
          max-width: 10px!important;
        }
      }
    }
  }
</style>